// NATIVE 

// INSTALLED 
import { at } from 'lodash';
import { useField } from 'formik';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { theme } from '../../commons/theme';

// CUSTOM 





export const UploadButtonField = (props:any) => {

    const { label, accept, name, text, onChange,  ...rest } = props;
    const [field, meta] = useField(props);


    function _renderHelperText() {
      const [touched, error] = at(meta, 'touched', 'error');
      
      if (touched && error) {
          return error;
      }
    }

    const VisuallyHiddenInput:any = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    

    // console.log(formikProps.values)
  return (
    <>
     <Button
        style={{ marginTop: 10, width: '100%' }}
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        onChange={ onChange }
        startIcon={<CloudUploadIcon />}
    >
        {text}
        <VisuallyHiddenInput 
                  type="file" 
                  accept={accept} 
                  name={name} 
                  
        />
    </Button>
    {
      (meta.touched && meta.error && true) && <p style={{ color: '#d32f2f' }}>{_renderHelperText()}</p>
    }
    
    </>
  )
}
